import React from "react";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslations } from "../../../hooks/use-translations";
import { useLanguage } from "../../../hooks/use-language";

export const Newsletter = () => {
	const lang = useLanguage();
	const textos = useTranslations({ section: "que_es", lang: lang });
	const newsletterTexts = textos?.boletin;
	const history = useHistory();
	const [email, setEmail] = useState("");

	const handleSubmit = (e) => {
		if (e) {
			e.preventDefault();
		}
		history.push({
			pathname: "/boletin/ingresar-datos",
			search: `?email=${email}`,
		});
	};
	return (
		<div className="newsletter-cta onbackground-primary--color">
			<div className="container">
				<div className="d-md-flex justify-content-center">
					<div className="shape">
						{/* <Img className="img-fluid accesible-image" src="" alt="newsletter-speaker"/> */}
					</div>
					<div
						className="py-3 col d-flex flex-column justify-content-center align-items-center"
						style={{ maxWidth: 700 }}
					>
						<div>
							<h5
								className="text-center text-sm-left onprimary--color title5"
								style={{ lineHeight: "1.3em", fontWeight: 600 }}
							>
								{newsletterTexts?.titulo ||
									"Suscríbete a nuestro boletín y entérate de eventos, promociones y actividades"}
							</h5>
							<form
								className="m-0 p-0 my-2 d-sm-flex flex-wrap align-items-center"
								onSubmit={(e) => handleSubmit(e)}
							>
								<input
									className="form-control col focusable-secondary text-16"
									onChange={(e) => setEmail(e?.target?.value)}
									placeholder={
										newsletterTexts?.input?.placeholder || "Correo electrónico"
									}
									type="email"
									required
								/>
								<div className="d-flex d-md-block col col-sm-4 m-0 p-0 justify-content-center justify-content-lg-end">
									<button className="primary-button p-2 px-3 mx-0 mt-3 m-sm-3 focusable-primary text-18">
										{newsletterTexts?.boton || "Suscribirme"}
									</button>
								</div>
								<p
									className="col-12 text-left d-none d-sm-block text-14"

								>
									{textos?.global?.terminos_condiciones_politica1 ||
										"Al ingresar tus datos estás aceptando"}{" "}
									<Link
										className="focusable-secondary onbackground-primary--color"
										to="/terminos-y-condiciones"
										style={{ fontWeight: 600 }}
									>
										{textos?.global?.terminos_condiciones_politica2 ||
											"Términos y condiciones"}
									</Link>{" "}
									{textos?.global?.terminos_condiciones_politica3 || "y"}{" "}
									<Link
										className="focusable-secondary onbackground-primary--color"
										to="/politica-de-privacidad"
										style={{ fontWeight: 600 }}
									>
										{textos?.global?.terminos_condiciones_politica4 ||
											"Política de privacidad"}
									</Link>
								</p>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
